import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

import toastr from '@/support/toastr';

export default {
	name: 'publish-all-homework',
	props: {
		disabled: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapGetters([
			'getClass',
			'getHomeworkList',
			'getAgendaDate',
			'getLoggedUser',
			'getHomeworkId'
		])
	},
	methods: {
		...mapActions([
			'saveHomeworkBySchoolClass',
			'publishAllHomeworkBySchoolClass',
			'setHomeworkList'
		]),
		publishAllHomeworks() {

			this.publishAllHomeworkBySchoolClass({
				id: this.getHomeworkId,
				themes: this.getHomeworkList,
				userId: this.getLoggedUser.id
			}).then((response) => {

				EventBus.$emit('homeworkPublishedAll');

				this.setHomeworkList(response.data);

				toastr.success(this.$gettext('Lições de casa publicadas com sucesso!'));
			});

		}
	}
};



// WEBPACK FOOTER //
// ./sources/domains/homework/publish-all/index.js